import { CardHeader } from './CardHeader';

// TODO: in v9, move styled() from CardHeader.jsx to here
export var StyledCardHeader = CardHeader;